import * as React from 'react';
import ServiceFooterSectionRow from './ServiceFooterSectionRow';

import css from './ServiceFooterSectionBody.module.scss';

interface Props {
  rows: Array<{ heading: string; links: Array<{ url: string; text: string }> }>;
}

const ServiceFooterSectionBody = (props: Props) => {
  return (
    <div className={css.ServiceFooterSectionBody}>
      {props.rows.map((row, index) => {
        return (
          <ServiceFooterSectionRow
            key={index}
            heading={row.heading}
            links={row.links}
          />
        );
      })}
    </div>
  );
};

export default ServiceFooterSectionBody;
